export const fetchData = (startDate, endDate, personId, excludedProjectId, projectMinutesAllocated) => {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const body = {
		method: 'POST',
		headers,
		credentials: 'include',
		body: JSON.stringify({
			startYear: startDate.year(),
			startMonth: startDate.month() + 1,
			startDay: startDate.date(),
			endYear: endDate.year(),
			endMonth: endDate.month() + 1,
			endDay: endDate.date(),
			personIds: [personId],
			excludedProjectId,
		}),
	};
	return fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'scheduling/utilization', body)
		.then(response => response.json())
		.then(data => {
			const distributionMap = new Map();
			Object.keys(data[personId].distribution).forEach(id => {
				distributionMap.set(id, data[personId].distribution[id]);
			});

			let minutesAllocated = data[personId].minutesAllocated;

			if (projectMinutesAllocated) {
				distributionMap.set(excludedProjectId, projectMinutesAllocated);
				minutesAllocated += projectMinutesAllocated;
			}

			return {
				distributionMap,
				minutesAllocated,
			};
		});
};

export const fetchDataByDay = (startDate, endDate, personId, excludedProjectId) => {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const body = {
		method: 'POST',
		headers,
		credentials: 'include',
		body: JSON.stringify({
			startYear: startDate.year(),
			startMonth: startDate.month() + 1,
			startDay: startDate.date(),
			endYear: endDate.year(),
			endMonth: endDate.month() + 1,
			endDay: endDate.date(),
			personIds: [personId],
			excludedProjectId,
		}),
	};
	return fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'scheduling/utilization_day', body)
		.then(response => response.json())
		.then(data => {
			let distributionMap = {};
			Object.keys(data).forEach(date => {
				distributionMap = {...distributionMap, [date]: data[date].transformedUtilizationMap[personId]};
			});
			return distributionMap;
		});
};
